import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTactics = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "currentColor",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		d: "m11.376 2.016-.356-.366-.359.363L8.34 4.361l.712.702 1.466-1.483v2.287a2.198 2.198 0 0 1-2.199 2.197H6.47a3.197 3.197 0 0 0-3.199 3.195v3.091h1v-3.091c0-1.213.985-2.197 2.2-2.197h1.847a3.197 3.197 0 0 0 3.2-3.195v-2.27l1.42 1.463.718-.696-2.28-2.348ZM2.5 4.39a1.461 1.461 0 1 1 2.923 0 1.461 1.461 0 0 1-2.923 0Zm1.462-2.46a2.46 2.46 0 1 0-.002 4.92 2.46 2.46 0 0 0 .002-4.921Zm6.615 9.811a1.461 1.461 0 1 1 2.922 0 1.461 1.461 0 0 1-2.922 0Zm1.461-2.46a2.46 2.46 0 1 0-.002 4.922 2.46 2.46 0 0 0 .002-4.922Z",
		clipRule: "evenodd"
	})
});
export default SvgTactics;
